import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class HDService {
  public url: any;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  cleanHDRecord(token: any, id: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.get<any>(
      `https://itaderp.com/backend/search-hd/clean-hd-record.php?apitoken=${token}&id=${id}`,
      { headers }
    );
  }

  addManuality(data: any, apiToken: any): Observable<any> {
    const fd = new FormData();
    fd.append('manufacturer', data.manufacturer);
    fd.append('model', data.model);
    fd.append('serial_number', data.serial_number);
    fd.append('results', data.results);
    fd.append('serial_number_new', data.serial_number_new);
    fd.append('po', data.po);

    const headers = new HttpHeaders({
      'Authorization': apiToken
    });

    return this._http.post<any>(
      'https://itaderp.com/backend/reports/add-manually-hd-record.php',
      fd,
      { headers }
    );
  }

  

  getHDDetails(token: any, startDate = null, endDate = null): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    let url = `https://itaderp.com/backend/search-hd/stats.php?id=1&apitoken=${token}`;

    if(startDate !== null && endDate !== null)
      url = url + `&startDate=${startDate}&endDate=${endDate}`;

    return this._http.get<any>(
      url,
      { headers }
    );
  }

  removebulk(token: any, json: any, apiToken: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'text/plain',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(
      `https://itaderp.com/backend/search-hd/remove-hd.php?apitoken=${apiToken}`,
      json,
      { headers }
    );
  }

    searchHDBySerialNumber(query: any, deepsearch: any, fecha: any, token: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    const dpsh = deepsearch.toString();
    fecha = fecha.toString();

    return this._http.get<any>(
      `https://itaderp.com/backend/search-hd/index.php?sn=${query}&dpsh=${dpsh}&fecha=${fecha}&apitoken=${token}`,
      { headers }
    );
  }

  searchHDByPO(query: any, deepsearch: any, token: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    const dpsh = deepsearch.toString();

    return this._http.get<any>(
      `https://itaderp.com/backend/search-hd/index.php?po=${query}&apitoken=${token}`,
      { headers }
    );
  }

    searchIQGetItemsByItemNumber(itemnumber: any, mfgr: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.get<any>(
      `https://www.itaderp.com/backend/search-hd/search_item_itemnumber.php?in=${itemnumber}&mfgr=${mfgr}`,
      { headers }
    );
  }

  searchpxe(token, serialNumber): Observable<any> {
    let json = JSON.stringify(serialNumber);
    json = encodeURIComponent(json);

    let params = 'json=' + json + '&authorization=' + token;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http
      .post(this.url + '/inventory/getepspxe', params, { headers: headers })
      .pipe(map((res) => res));
  }


}
